import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from '../../ApplicationRecord';
import type AuditsExport from '../AuditsExport';

@Model()
class AuditsExportsAllInvoice extends ApplicationRecord {
  static jsonapiType = 'audits-exports-all_invoices' as const;

  // Attributes
  @Attr() startDate!: string;

  // Extra-attributes

  // Relationships
  @HasOne('audits-exports') export!: AuditsExport;
}

export default AuditsExportsAllInvoice;
